import { Component, OnInit } from '@angular/core';
import { ApplicationSteps } from "../../../../models/applications.models";
import { ApplicationSectionBaseComponent } from "../../../application-section-base/application-section-base.component";
import { AuthService } from "../../../../../services/auth.service";

@Component({
    selector: 'app-organization-information',
    templateUrl: './organization-information.component.html',
    styleUrls: ['./organization-information.component.scss', '../../../../../core/components/collapsible/collapsible.component.scss', '../../../application-section-base/application-section-base.component.scss'],
    standalone: false
})
export class OrganizationInformationComponent extends ApplicationSectionBaseComponent implements OnInit {

    readonly step: ApplicationSteps = ApplicationSteps.VerifyOwner;

    constructor(_auth: AuthService) {
        super(_auth);
    }

    ngOnInit() {
    }

    toggleOpen(): void {
        if (this.step == this.activeStep || !this.isOpen) super.toggleOpen();
        this.openChanged.emit(this.step);
    }
}
